import React from 'react';
import type { SupplementEntry } from '../../../types/mealTracking';
import {
  formatMealDisplayTime,
  formatSupplementAmount,
  resolveSupplementFrequencyLabel,
} from '../mealTracking.utils';
import MealOverflowMenu from './MealOverflowMenu';
import styles from './SupplementCard.module.css';

interface SupplementCardProps {
  supplement: SupplementEntry;
  onEdit: () => void;
  onDelete: () => void;
}

const SupplementCard: React.FC<SupplementCardProps> = ({
  supplement,
  onEdit,
  onDelete,
}) => (
  <article className={styles.card}>
    <div className={styles.time}>{formatMealDisplayTime(supplement.time)}</div>

    <div className={styles.content}>
      <h3 className={styles.title}>{supplement.name}</h3>
      <p className={styles.meta}>
        {formatSupplementAmount(supplement)}
        {' · '}
        {resolveSupplementFrequencyLabel(supplement)}
        {supplement.brand ? ` · ${supplement.brand}` : ''}
      </p>
    </div>

    <div className={styles.actions}>
      <button type="button" className={styles.editLink} onClick={onEdit}>
        Editar
      </button>
      <MealOverflowMenu onDelete={onDelete} deleteLabel="Excluir suplemento" />
    </div>
  </article>
);

export default SupplementCard;
